export default [
	{
		modulo: 39,
		privilegio: 418,
		routerName: 'casos-medicos',
		routerPath: '/casos-medicos',
		componentName: 'CasosMedicos',
		componentPath: 'modules/layout/atendimento-aeromedico/casos-medicos/main'
	},
	{
		modulo: 39,
		privilegio: 419,
		routerName: 'cadastro-comunidade',
		routerPath: '/comunidade',
		componentName: 'Comunidade',
		componentPath: 'modules/layout/atendimento-aeromedico/comunidade/main'
	},
	{
		modulo: 39,
		privilegio: 420,
		routerName: 'ficha-pre-hospitalar',
		routerPath: '/ficha-pre-hospitalar',
		componentName: 'FichaPreHospitalar',
		componentPath: 'modules/layout/atendimento-aeromedico/ficha-pre-hospitalar/main'
	},
	{
		modulo: 39,
		privilegio: 421,
		routerName: 'cadastrar-ficha-atendimento-pre-hospitalar',
		routerPath: '/cadastro-ficha-pre-hospitalar',
		componentName: 'CadastroFichaPreHospitalar',
		componentPath: 'modules/layout/atendimento-aeromedico/ficha-pre-hospitalar/cadastro/main'
	},
	{
		modulo: 39,
		privilegio: 421,
		props: true,
		routerName: 'editar-ficha-pre-hospitalar',
		routerPath: '/editar-ficha-pre-hospitalar/:id',
		componentName: 'CadastroFichaPreHospitalar',
		componentPath: 'modules/layout/atendimento-aeromedico/ficha-pre-hospitalar/cadastro/main'
	},
	{
		modulo: 39,
		privilegio: 425,
		routerName: 'filtro-relatorio-epidemiologico',
		routerPath: '/relatorio-epidemiologico',
		componentName: 'FiltroRelatorioEpidemiologico',
		componentPath: 'modules/layout/atendimento-aeromedico/relatorio-epidemiologico/filtro-relatorio-epidemiologico'
	},

]
